import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useI18n } from "@/context/I18nContext";
import { ArrowUpRight } from "lucide-react";

const RELATED_APPS = [
  { name: "Nexxaris", url: "https://www.nexxaris.com" },
  { name: "Certytrace", url: "https://www.certytrace.store" },
  { name: "Business Plan", url: "https://businessplan.ratingonline.store" },
];

const CONTACT_EMAIL = "info@ratingonline.store";

export function SiteFooter() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-slate-800 bg-slate-950" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div className="max-w-xs">
            <Logo size="sm" />
            <p className="mt-3 text-xs leading-relaxed text-slate-400">{t("footer_tagline")}</p>
          </div>

          <nav aria-label={t("footer_related")}>
            <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-slate-500 mb-3">{t("footer_related")}</p>
            <ul className="space-y-2">
              {RELATED_APPS.map((a) => (
                <li key={a.name}>
                  <a href={a.url} target="_blank" rel="noopener noreferrer"
                    data-testid={`footer-link-${a.name.toLowerCase().replace(/\s+/g, "-")}`}
                    className="group inline-flex items-center gap-1 text-sm text-slate-300 hover:text-blue-400 transition-colors duration-200">
                    {a.name}
                    <ArrowUpRight className="h-3.5 w-3.5 text-slate-500 group-hover:text-blue-400 transition-[color,transform] duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label={t("footer_legal")}>
            <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-slate-500 mb-3">{t("footer_legal")}</p>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" data-testid="footer-link-privacy"
                  className="text-sm text-slate-300 hover:text-blue-400 transition-colors duration-200">{t("footer_privacy")}</Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-link-terms"
                  className="text-sm text-slate-300 hover:text-blue-400 transition-colors duration-200">{t("footer_terms")}</Link>
              </li>
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-link-contact"
                  className="text-sm text-slate-300 hover:text-blue-400 transition-colors duration-200">{t("footer_contact")}</a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-8 pt-6 border-t border-slate-800 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Rexxpons · Rating & Analisi del Credito. {t("footer_rights")}</span>
          <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-blue-400 transition-colors">{CONTACT_EMAIL}</a>
        </div>
      </div>
    </footer>
  );
}
